import {useState} from 'react';

import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {PasswordValidations} from '../../../components/PasswordValidations/PasswordValidations';
import {SimpleFormikForm} from '../../../components/SimpleFormikForm/SimpleFormikForm';
import {FieldType} from '../../../components/SimpleFormikForm/types';
import {validatePasswordsMatch, validatePasswordStrength} from '../../../utils/validators';

interface FormValues {
  password: string;
  passwordRepeat: string;
}

interface Props {
  onSubmit: (password: string, passwordRepeat: string) => void;
}
export const PasswordReset = ({onSubmit}: Props) => {
  const {t} = useTranslation();
  const [passwordValue, setPasswordValue] = useState('');

  const handleSubmit = (values: FormValues) => {
    onSubmit(values.password, values.passwordRepeat);
  };

  const validate = (values: FormValues) => {
    const errors: {[key: string]: string} = {};

    if (values.password && !validatePasswordStrength(values.password)) {
      errors.password = t('registration.signUp.formLabels.errorMessages.invalidPassword');
    }

    if (values.passwordRepeat && !validatePasswordsMatch(values.password, values.passwordRepeat)) {
      errors.passwordRepeat = t('passwordReset.passwordNotMatching');
    }

    if (!values.password || !values.passwordRepeat) {
      errors.missingFields = 'true';
    }

    return errors;
  };

  const onPasswordChange = (value: string) => {
    setPasswordValue(value);
  };

  const initialValues = {password: '', passwordRepeat: ''};
  const fields: FieldType<keyof FormValues>[] = [
    {
      onChangeListener: onPasswordChange,
      componentType: 'text-field',
      id: 'password',
      fieldName: 'password',
      type: 'password',
      fieldLabel: t('passwordReset.passwordLabel') || 'Password',
      testId: 'password-reset-field',
      autoComplete: 'new-password',
    },
    {
      componentType: 'text-field',
      id: 'passwordRepeat',
      fieldName: 'passwordRepeat',
      type: 'password',
      fieldLabel: t('passwordReset.passwordRepeatLabel') || 'Repeat Password',
      testId: 'password-confirmation-field',
      autoComplete: 'repeat-password',
    },
  ];

  return (
    <Grid sx={{maxWidth: '544px'}}>
      <Grid display='flex' justifyContent='center'>
        <Typography variant='h1' paddingBottom='16px'>
          {t('passwordReset.title')}
        </Typography>
      </Grid>
      <PasswordValidations password={passwordValue} />
      <SimpleFormikForm
        initialValues={initialValues}
        buttonText={t('passwordReset.button')}
        validate={validate}
        fields={fields}
        onSubmit={handleSubmit}
      />
    </Grid>
  );
};
